"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../libs/types");
var util_1 = require("../libs/util");
var api_1 = require("../api");
exports.FLAG = Symbol.for('__schema_format_type__');
exports.META = Symbol.for('__schema_metadata__');
/**
 * we classify the inline & block by this flag
 * block made by node, inline made by marks
 * detail: https://discuss.prosemirror.net/t/discussion-what-are-marks/862
 */
var FORMAT_TYPE;
(function (FORMAT_TYPE) {
    FORMAT_TYPE[FORMAT_TYPE["CARD"] = 8] = "CARD";
    FORMAT_TYPE[FORMAT_TYPE["INLINE"] = 2] = "INLINE";
    FORMAT_TYPE[FORMAT_TYPE["BLOCK"] = 1] = "BLOCK";
    FORMAT_TYPE[FORMAT_TYPE["INLINE_CARD"] = 10] = "INLINE_CARD";
    FORMAT_TYPE[FORMAT_TYPE["BLOCK_CARD"] = 9] = "BLOCK_CARD"; // 1001
})(FORMAT_TYPE = exports.FORMAT_TYPE || (exports.FORMAT_TYPE = {}));
var SylSchema = /** @class */ (function () {
    function SylSchema(editor, props) {
        this.name = '';
        this.parseDOM = [];
    }
    SylSchema = __decorate([
        Reflect.metadata(exports.FLAG, FORMAT_TYPE.BLOCK),
        __metadata("design:paramtypes", [api_1.SylApi, Object])
    ], SylSchema);
    return SylSchema;
}());
exports.SylSchema = SylSchema;
// it is schema type checking utilities, can used to get type
// information about Inline/Card/InlineCard/Block
(function (SylSchema) {
    function isCard(Ctor) {
        return checkType(Ctor, FORMAT_TYPE.CARD);
    }
    SylSchema.isCard = isCard;
    function isInline(Ctor) {
        return checkType(Ctor, FORMAT_TYPE.INLINE);
    }
    SylSchema.isInline = isInline;
    function isBlock(Ctor) {
        return checkType(Ctor, FORMAT_TYPE.BLOCK);
    }
    SylSchema.isBlock = isBlock;
    function getType(ctor) {
        // it is class type and get meta directly
        if (util_1.Utils.isFunction(ctor)) {
            var flag = Reflect.getMetadata(exports.FLAG, ctor);
            return Boolean(flag) ? FORMAT_TYPE[flag] : null;
        }
        return getSuperTypes(ctor, function (flag) { return Boolean(FORMAT_TYPE[flag]); });
    }
    SylSchema.getType = getType;
    // check schema type, can receive both pure object & class type
    function checkType(current, type) {
        if (util_1.Utils.isFunction(current)) {
            var flag = Reflect.getMetadata(exports.FLAG, current);
            return Boolean(flag) && Boolean(flag & type);
        }
        return Boolean(getSuperTypes(current, function (flag) { return Boolean(flag ^ type); }));
    }
    // if current object constructor has no FORMAT_TYPE meta,
    // we find its super recursive to get meta
    function getSuperTypes(current, checker) {
        if (!util_1.Utils.isPureObject(current)) {
            return null;
        }
        while (current) {
            if (Reflect.has(current.constructor, exports.FLAG)) {
                var flag = Reflect.getMetadata(exports.FLAG, current);
                return checker(flag) ? FORMAT_TYPE[flag] : null;
            }
            var proto = Object.getPrototypeOf(current);
            if (proto) {
                current = proto;
            }
            break;
        }
        return null;
    }
})(SylSchema = exports.SylSchema || (exports.SylSchema = {}));
exports.SylSchema = SylSchema;
/**
 * this will decorate the format class to set basic property of leaf or
 * descriptive node info
 * there are some changing comparing with tt-editor-v3-core:
 * 1. changing the name of blot name - get rid of blot concept
 * 2. get rid of value option - origin for quill converter method
 * 3. get rid of close Icon - maybe move it to access layer is a better choice
 * 4. get rid of contenteditable
 * 5. changing domMatcher
 *
 *
 * name: schema's name, origin - schema key
 * tagName: inherit from quill, use it to make dom structure, only allow single
 * attrs: store all of the states of this node
 * group: classify inline - block - or others, should offer inline/block/card/InlineCard
 * allowChildrens: children allowed, can use bother Scope or schema name
 * untouchable: define the structure cannot be deleted
 * markMatcher: match specified text mark such as {!-- PGC:{**json**} --}
 * textMatcher: listen shortcut before the place of inputing
 * uniqKey: only allow one instance of same key
 */
var Formattable = /** @class */ (function (_super) {
    __extends(Formattable, _super);
    function Formattable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = null;
        _this.tagName = function (node) { return ''; };
        _this.untouchable = false;
        _this.uniqKey = false;
        _this.toDOM = function (node) {
            return createWrapperDOM(_this.tagName(node));
        };
        return _this;
    }
    return Formattable;
}(SylSchema));
exports.Formattable = Formattable;
(function (Formattable) {
    Formattable.keymap = null;
    Formattable.NodeView = null;
})(Formattable = exports.Formattable || (exports.Formattable = {}));
exports.Formattable = Formattable;
// used to describe semantic block, same as `block` in css
var Block = /** @class */ (function (_super) {
    __extends(Block, _super);
    function Block(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.group = 'block';
        _this.tagName = function (node) { return 'p'; };
        _this.content = 'inline*';
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs, Boolean(_this.content)); };
        _this.defining = true;
        return _this;
    }
    Block = __decorate([
        Reflect.metadata(exports.FLAG, FORMAT_TYPE.BLOCK),
        __metadata("design:paramtypes", [api_1.SylApi, Object])
    ], Block);
    return Block;
}(Formattable));
exports.Block = Block;
/**
 * used to describe sematic inline, same as `inline` in css
 * notClear 调用sylAPI.clearFormat时不被清除
 * notStore 删除mark的输入之后再输入不保存mark
 */
var Inline = /** @class */ (function (_super) {
    __extends(Inline, _super);
    function Inline(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.group = 'inline';
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs, true); };
        _this.inline = true;
        return _this;
    }
    Inline = __decorate([
        Reflect.metadata(exports.FLAG, FORMAT_TYPE.INLINE),
        __metadata("design:paramtypes", [api_1.SylApi, Object])
    ], Inline);
    return Inline;
}(Formattable));
exports.Inline = Inline;
// custom type, could not be divided， semantic same as `char`,
// but more expressive
var Atom = /** @class */ (function (_super) {
    __extends(Atom, _super);
    function Atom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLeaf = true;
        // an Atom Format with untouchable is truthy means it cannot selected
        // or deleted
        _this.untouchable = false;
        // an Atom Format with uniqueKey means its instance cannot appear in the editor if same uniqueKey
        // has been in contenteditable area
        _this.uniqueKey = false;
        _this.markMatcher = [];
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs, false); };
        return _this;
    }
    Object.defineProperty(Atom.prototype, "selectable", {
        get: function () {
            return !this.untouchable;
        },
        enumerable: true,
        configurable: true
    });
    Atom = __decorate([
        Reflect.metadata(exports.FLAG, FORMAT_TYPE.CARD)
    ], Atom);
    return Atom;
}(Formattable));
var BlockAtom = /** @class */ (function (_super) {
    __extends(BlockAtom, _super);
    function BlockAtom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'block';
        return _this;
    }
    BlockAtom = __decorate([
        Reflect.metadata(exports.FLAG, FORMAT_TYPE.BLOCK_CARD)
    ], BlockAtom);
    return BlockAtom;
}(Atom));
exports.BlockAtom = BlockAtom;
var InlineAtom = /** @class */ (function (_super) {
    __extends(InlineAtom, _super);
    function InlineAtom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'inline';
        _this.inline = true;
        return _this;
    }
    InlineAtom = __decorate([
        Reflect.metadata(exports.FLAG, FORMAT_TYPE.INLINE_CARD)
    ], InlineAtom);
    return InlineAtom;
}(Atom));
exports.InlineAtom = InlineAtom;
function createWrapperDOM(tagName, _attrs, _contents) {
    var attrs = _attrs || {};
    var contents = _contents || false;
    if (attrs === undefined) {
        attrs = {};
        contents = false;
    }
    else if (typeof attrs === 'boolean') {
        contents = attrs;
        attrs = {};
    }
    else {
        contents = contents || false;
    }
    var displayAttrs = {};
    Object.keys(attrs).forEach(function (key) {
        var attr = attrs[key];
        if (attr)
            displayAttrs[key] = attr;
    });
    var pDOM = [tagName, displayAttrs];
    if (Boolean(contents)) {
        pDOM[2] = 0;
    }
    return pDOM;
}
// every plugin will generate a schemaMeta instance, it is actually can be
// used by ProseMirror, its `config` property is actually a SchemaSpec
var SchemaMeta = /** @class */ (function () {
    function SchemaMeta(formatType, name, config) {
        this.formatType = formatType;
        this.name = name;
        this.config = config;
    }
    SchemaMeta.prototype.getDisplay = function () {
        if (this.formatType & FORMAT_TYPE.INLINE) {
            if (this.formatType === FORMAT_TYPE.INLINE_CARD) {
                return 'nodes';
            }
            return 'marks';
        }
        return 'nodes';
    };
    return SchemaMeta;
}());
exports.SchemaMeta = SchemaMeta;
//# sourceMappingURL=schema.js.map